import { t } from "i18next";
import { enqueueSnackbar } from "notistack";

import { apiClient } from "../../ApiClient";
import { BACKEND_METHOD_TO_INTEGRATION } from "../constants";
import { GetState, SetState, Store, StoreData } from "../types";

import { setIntegrationMethod } from "./setIntegrationMethod";

export const initialize = (set: SetState<StoreData>, get: GetState<Store>) => async () => {
  const integrationId = get().integrationId;

  if (integrationId === undefined) {
    console.warn("Integration ID is undefined");
    return;
  }

  try {
    const response = await apiClient.integrations.getIntegrationsId(integrationId);

    const integration = response.data;
    set((s: StoreData) => ({
      isInitialized: true,
      integration,
      environment: integration.environment ?? s.environment,
    }));

    const mappedMethod = integration.method
      ? BACKEND_METHOD_TO_INTEGRATION[integration.method]
      : undefined;
    setIntegrationMethod(set)(mappedMethod);
  } catch (error) {
    enqueueSnackbar(t("error.title"));
  }
};
